/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import ArgonDashboard from "./plugins/argon-dashboard";
import APP_CONFIG from "./config/config";
import { userHelper } from "./helpers/user-helper";
import { store } from "./store";
import { axios } from "./axios";
import $ from "jquery";
import "./registerServiceWorker";
window.$ = $;
window.jQuery = $;

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: APP_CONFIG.GOOGLE_MAP_KEY,
    libraries: "places",
  },
});

// VueLidate
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// Confirm Dialog
import VuejsDialog from "vuejs-dialog";
Vue.use(VuejsDialog);

// MomentJS
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});

// Datatables
import { VuejsDatatableFactory } from "vuejs-datatable";
Vue.use(VuejsDatatableFactory);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  const authRequired = !to.meta.noAuth;
  const loggedIn = localStorage.getItem("user");

  if (loggedIn) {
    const parsed = JSON.parse(loggedIn);

    if (!to.path.includes("/phrases") && parsed.phrases.length < 1) {
      return next("/phrases");
    } else if (
      parsed.phrases.length > 0 &&
      !to.path.includes("/categories") &&
      parsed.categories.length < 1
    ) {
      return next("/categories");
    }
  } else if (authRequired && !loggedIn) {
    return next("/login");
  }
  next();
});

import "./main.css";
import "./tailwind.css";
import "@/assets/vendor/nucleo/css/nucleo.css";
import "@/assets/scss/argon.scss";
Vue.use(ArgonDashboard);

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
Vue.use(Toast);

import {
  Datepicker,
  Timepicker,
  DatetimePicker,
  DateRangePicker,
} from "@livelybone/vue-datepicker";
// css
import "@livelybone/vue-datepicker/lib/css/index.css";

// Global register
Vue.component("datepicker", Datepicker);
Vue.component("timepicker", Timepicker);
Vue.component("datetime-picker", DatetimePicker);
Vue.component("date-range-picker", DateRangePicker);

import VueSwal from "vue-swal";

Vue.use(VueSwal);

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "vue-multi-select/dist/lib/vue-multi-select.css";

Vue.use(flatPickr);

Vue.prototype.$APP_CONFIG = APP_CONFIG;
Vue.prototype.$CURRENT_USER = userHelper;

import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-QM8VMC5CHN",
      params: {},
    },
  },
  router
);

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "486113847",
  router,
});

new Vue({
  router,
  store,
  axios,
  render: (h) => h(App),
}).$mount("#app");
